// extracted by mini-css-extract-plugin
module.exports = {"TechnicalPause":"TechnicalPause_TechnicalPause__1t1xW","Header":"TechnicalPause_Header__gEPVP","P":"TechnicalPause_P__8JQK2"};